import { BadgeV3, Menu } from '@cimplico/components';
import { PaperClipIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { FileRecordNew } from '../../../../types/file-record';

import { WorksheetFileOverview } from '../../../../types/worksheet';
import ViewErrorDialog from '../../../../features/files/ViewErrorDialog';
import AttachmentBrowser from './AttachmentBrowser';

type EntryFileAttachMenuProps = {
    attachments: string[];
    defaultFolderId: string;
    worksheetFiles: WorksheetFileOverview[];
    onAttach: (fileIds: string[]) => void;
    disabled?: boolean;
    isOpen: boolean;
    onOpenToggle: (open: boolean) => void;
};

function EntryFileAttachMenu({
    isOpen,
    onOpenToggle,
    attachments,
    defaultFolderId,
    onAttach,
    worksheetFiles,
    disabled = false,
}: EntryFileAttachMenuProps): JSX.Element {
    const [_attachments, setAttachments] = useState(attachments);

    function handleChange(values: string[]): void {
        setAttachments(values);
        onAttach(values);
    }

    useEffect(() => {
        setAttachments(attachments);
    }, [attachments]);

    return (
        <>
            <Menu>
                <Menu.Button onClick={(): void => onOpenToggle(!isOpen)} className="outline-0 min-w-[45px]">
                    <div className="-mb-[2px] mx-auto w-max">
                        {_attachments.length === 0 && <PaperClipIcon className="text-gray-700 h-4 w-4 mt-[4px]" />}
                        {_attachments.length > 0 && (
                            <BadgeV3 leftIcon={<PaperClipIcon />} color="indigo" label={_attachments.length.toString()} rounded />
                        )}
                    </div>
                </Menu.Button>
                <Menu.Body position="left" isOpen={isOpen}>
                    <AttachmentBrowser
                        attachments={_attachments}
                        defaultFolderId={defaultFolderId}
                        onAttach={handleChange}
                        worksheetFiles={worksheetFiles}
                        disabled={disabled}
                        onClose={(): void => onOpenToggle(false)}
                    />
                </Menu.Body>
            </Menu>
        </>
    );
}
export default EntryFileAttachMenu;
